import React, { useState, useEffect } from 'react';
import classNames from 'classnames';
import { useDispatch } from 'react-redux';
import moment from 'moment';
import isEmpty from 'lodash/isEmpty';
import '@ant-design/compatible/assets/index.css';
import { DatePicker, Select, Input, Button, Row, Col, AutoComplete, message, Spin } from 'antd';
import { useTranslation } from 'react-i18next';
import { dayFormatType, formatDay } from '~helpers/day';
import * as actions from '~actions/reconciliation';
import debounce from 'lodash/debounce';
import { useQuery } from '@apollo/client';
import { Form, Icon as LegacyIcon } from '@ant-design/compatible';
import {
  bookingLandlordStatus,
  secondaryLandlordBookingStatus as secondaryLandlordBookingStatusObj,
} from '~constants/reconciliation-booking';
import { formatUppercaseLetters } from '~helpers/change-log';
import { Base64 } from 'js-base64';
import { marketsList } from './enum';
import { QUERY_PropertyName } from './queries';
import { CountryFilterSelect } from '~client/components/filters/country-filters';

function ConsultantReconciliationFilter({ form, handleQueryList }) {
  const { t } = useTranslation();
  const [filterForm, setFilterForm] = useState({
    market: [],
    landlordSlug: null,
    cityIds: null,
    countryIds: null,
    landlordIds: null,
    propertyIds: null,
    landlordBookingStatuses: 'All',
    secondaryLandlordBookingStatus: 'All',
    moveInDate: null,
    moveOutDate: null,
    createdDate: null,
    completedDate: null,
    invoiceNumber: null,
    referenceId: null,
  });

  const dispatch = useDispatch();
  const { getFieldDecorator, validateFields } = form;
  const dateFormat = dayFormatType.UKFORMAT;
  const [showMore, setShowMore] = useState(true);
  const [landlordData, setLandlordData] = useState([]);
  const [propertyData, setPropertyData] = useState(null);
  // const [countryData, setCountryData] = useState([]);
  const [cityData, setCityData] = useState([]);

  const [cityIdParam, setCityIdParam] = useState(null);
  const [landlordSlugParam, setLandLordSlugParam] = useState(null);
  const {
    loading: propertyLoading,
    data: propertyNames,
    refetch: queryPropertyNames,
  } = useQuery(QUERY_PropertyName, {
    variables: {
      pageNumber: 1,
      pageSize: 20,
      query: propertyData,
    },
    fetchPolicy: 'cache-and-network',
    onError: e => {
      message.error(e?.toString());
    },
    // onCompleted: () => {
    //   setPropertyData(propertyNames?.edges);
    // },
  });

  const handleFilter = () => {
    validateFields((err, values) => {
      if (!err) {
        if (values) {
          // if ( values?.countryIds?.length) {
          //   return message.info(t('cms.reconciliation.list.table.filter.country.error_message'));
          // }
          if (values?.cityIds && !cityIdParam) {
            return message.info(t('cms.reconciliation.list.table.filter.city.error_message'));
          }

          if (values?.landlordSlug && !landlordSlugParam) {
            return message.info(
              t('cms.reconciliation.list.table.filter.landlord_name.error_message'),
            );
          }
          // if (values?.propertyIds && !propertyIdsParam) {
          //   return message.info(
          //     t('cms.reconciliation.list.table.filter.property_name.error_message'),
          //   );
          // }

          const landlordIds = values?.landlordIds
            ? [
                Base64.btoa(
                  JSON.stringify({
                    type: 'Landlord',
                    id: values?.landlordIds,
                  }),
                ),
              ]
            : [];
          const landlordSlug = values?.landlordSlug && landlordSlugParam ? [landlordSlugParam] : [];

          const landlordIdsArr = [...landlordIds, ...landlordSlug];
          let marketNew = null;
          let landlordBookingStatusesNew = null;
          let secondaryLandlordBookingStatusNew = null;
          if (values?.market?.length > 0) {
            marketNew = values?.market;
          } else {
            marketNew = null;
          }

          if (values?.landlordBookingStatuses?.length) {
            landlordBookingStatusesNew = values?.landlordBookingStatuses;
          } else {
            landlordBookingStatusesNew = null;
          }

          if (
            values?.secondaryLandlordBookingStatus &&
            values?.secondaryLandlordBookingStatus !== 'All'
          ) {
            secondaryLandlordBookingStatusNew = values?.secondaryLandlordBookingStatus;
          } else {
            secondaryLandlordBookingStatusNew = null;
          }

          const variables = {
            markets: marketNew,
            cityIds: values?.cityIds && cityIdParam ? [cityIdParam] : null,
            countryIds: values?.countryIds || null,
            landlordIds: landlordIdsArr?.length ? landlordIdsArr : null,
            propertyIds: values?.propertyIds,
            landlordBookingStatuses: landlordBookingStatusesNew,
            secondaryLandlordBookingStatus: secondaryLandlordBookingStatusNew,
            finalMoveInDateStart: values.moveInDate[0]
              ? formatDay(dayFormatType.FILTERPARAMS, values.moveInDate[0])
              : null,
            finalMoveInDateEnd: values.moveInDate[1]
              ? formatDay(dayFormatType.FILTERPARAMS, values.moveInDate[1])
              : null,
            finalMoveOutDateStart: values.moveOutDate[0]
              ? formatDay(dayFormatType.FILTERPARAMS, values.moveOutDate[0])
              : null,
            finalMoveOutDateEnd: values.moveOutDate[1]
              ? formatDay(dayFormatType.FILTERPARAMS, values.moveOutDate[1])
              : null,

            createdAtStart: values.createdDate[0]
              ? formatDay(dayFormatType.FILTERPARAMS, values.createdDate[0])
              : null,
            createdAtEnd: values.createdDate[1]
              ? formatDay(dayFormatType.FILTERPARAMS, values.createdDate[1])
              : null,
            completedAtStart: values.completedDate[0]
              ? formatDay(dayFormatType.FILTERPARAMS, values.completedDate[0])
              : null,
            completedAtEnd: values.completedDate[1]
              ? formatDay(dayFormatType.FILTERPARAMS, values.completedDate[1])
              : null,
            invoiceNumber: isEmpty(values?.invoiceNumber) ? null : values?.invoiceNumber,
            referenceId: isEmpty(values?.referenceId) ? null : values?.referenceId,
          };
          handleQueryList(variables);
        }
      }
    });
  };

  const handleResetBtn = () => {
    form.resetFields();
    setFilterForm({
      market: [],
      landlordSlug: null,
      cityIds: null,
      countryIds: null,
      landlordIds: null,
      propertyIds: null,
      landlordBookingStatuses: null,
      secondaryLandlordBookingStatus: 'All',
      moveInDate: null,
      moveOutDate: null,
      createdDate: null,
      completedDate: null,
      invoiceNumber: null,
      referenceId: null,
    });
    handleQueryList({});
    setCityIdParam(null);
    setLandLordSlugParam(null);
  };

  const handleShowMoreBtn = () => {
    setShowMore(!showMore);
  };

  const handleQueryLandlord = value => {
    dispatch(
      actions.searchLandlordList(value, res => {
        const data = res?.search?.edges ?? [];
        setLandlordData(data);
      }),
    );
  };

  const handleQueryProperty = debounce(value => {
    setPropertyData(value);
    queryPropertyNames();
  }, 800);

  // const handleQueryCountry = value => {
  //   dispatch(
  //     actions.searchCountryList(value, res => {
  //       const data = res?.search?.edges ?? [];
  //       setCountryData(data);
  //     }),
  //   );
  // };

  const handleQueryCity = value => {
    dispatch(
      actions.searchCityList(value, res => {
        const data = res?.search?.edges ?? [];
        setCityData(data);
      }),
    );
  };

  useEffect(() => {
    if (isEmpty(filterForm)) {
      form.resetFields();
    }
  }, [filterForm]);

  return (
    <div className="consultant-reconciliation__filter" style={{ paddingBottom: showMore ? 12 : 0 }}>
      <Form className="consultant-reconciliation__filter__form">
        <Row gutter={24}>
          <Col span={8}>
            <Form.Item
              className="consultant-reconciliation__filter__item"
              label={t('cms.reconciliation.list.table.filter.destination_market')}
            >
              {getFieldDecorator('market', {
                initialValue: filterForm?.market ?? [],
              })(
                <Select
                  mode="multiple"
                  placeholder={t('cms.reconciliation.list.table.filter.destination_market')}
                >
                  {marketsList.map(item => {
                    return (
                      <Select.Option key={item.label} value={item.value}>
                        {item.label}
                      </Select.Option>
                    );
                  })}
                </Select>,
              )}
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              className="consultant-reconciliation__filter__item"
              label={t('cms.reconciliation.list.table.filter.destination_country')}
            >
              {getFieldDecorator('countryIds', {})(<CountryFilterSelect fields="countryIds" />)}
            </Form.Item>
          </Col>

          <Col
            span={8}
            className={classNames({
              'consultant-reconciliation__filter__col--hidden': showMore,
            })}
          >
            <Form.Item
              className="consultant-reconciliation__filter__item"
              label={t('cms.reconciliation.lead_generation.filter.destination_city')}
            >
              {getFieldDecorator('cityIds', {
                // initialValue: filterForm?.cityIds ?? null,
                initialValue: cityIdParam ?? null,
              })(
                <AutoComplete
                  onSelect={value => {
                    setCityIdParam(value);
                  }}
                  onChange={e => {
                    setCityIdParam(null);
                    handleQueryCity(e);
                  }}
                  placeholder={t('cms.reconciliation.lead_generation.filter.destination_city')}
                >
                  <For of={cityData} each="item">
                    <AutoComplete.Option key={item?.node?.id} value={item?.node?.id}>
                      {item?.node?.name}
                    </AutoComplete.Option>
                  </For>
                </AutoComplete>,
              )}
            </Form.Item>
          </Col>
        </Row>
        <Row
          gutter={24}
          className={classNames({
            'consultant-reconciliation__filter__row--hidden': showMore,
          })}
        >
          <Col span={8}>
            <Form.Item
              className="consultant-reconciliation__filter__item"
              label={t('cms.reconciliation.list.table.filter.landlord_name')}
            >
              {getFieldDecorator('landlordSlug', {
                // initialValue: filterForm?.landlordSlug ?? null,
                initialValue: landlordSlugParam ?? null,
              })(
                <AutoComplete
                  onSelect={value => {
                    setLandLordSlugParam(value);
                  }}
                  onChange={value => {
                    setLandLordSlugParam(null);
                    handleQueryLandlord(value);
                  }}
                  placeholder={t('cms.reconciliation.list.table.filter.landlord_name')}
                >
                  <For of={landlordData} each="item">
                    <AutoComplete.Option key={item?.node?.id} value={item?.node?.id}>
                      {item?.node?.name}
                    </AutoComplete.Option>
                  </For>
                </AutoComplete>,
              )}
            </Form.Item>
          </Col>
          {/* <Col span={8}>
            <Form.Item
              className="consultant-reconciliation__filter__item"
              label={t('cms.reconciliation.list.table.filter.landlord_ID')}
            >
              {getFieldDecorator('landlordIds', {
                initialValue: filterForm?.landlordIds ?? null,
              })(<Input placeholder={t('cms.reconciliation.list.table.filter.landlord_ID')} />)}
            </Form.Item>
          </Col> */}
          <Col span={8}>
            <Form.Item
              className="consultant-reconciliation__filter__item"
              label={t('cms.reconciliation.list.table.filter.property_name')}
            >
              {getFieldDecorator(
                'propertyIds',
                {},
              )(
                <Select
                  mode="multiple"
                  fileds="propertyIds"
                  filterOption={false}
                  onSearch={handleQueryProperty}
                  notFoundContent={propertyLoading ? <Spin size="small" /> : null}
                  // loading={propertyLoading}
                  onChange={value => {
                    console.log(value);
                  }}
                  placeholder={t('cms.reconciliation.list.table.filter.property_name')}
                >
                  <For of={propertyNames?.search?.edges || []} each="item">
                    <Select.Option key={item?.node?.id} value={item?.node?.id}>
                      {item?.node?.name}
                    </Select.Option>
                  </For>
                </Select>,
              )}
            </Form.Item>
          </Col>
        </Row>
        <Row
          gutter={24}
          className={classNames({
            'consultant-reconciliation__filter__row--hidden': showMore,
          })}
        >
          <Col span={8}>
            <Form.Item
              className="consultant-reconciliation__filter__item"
              label={t('cms.reconciliation.list.table.filter.landlord_booking_status')}
            >
              {getFieldDecorator(
                'landlordBookingStatuses',
                {},
              )(
                <Select
                  mode="multiple"
                  placeholder={t('cms.reconciliation.list.table.filter.landlord_booking_status')}
                >
                  <For of={[...Object.keys(bookingLandlordStatus)]} each="type">
                    <Select.Option value={type} key={type}>
                      {formatUppercaseLetters(type?.toLowerCase?.()?.split?.('_')?.join?.(' '))}
                    </Select.Option>
                  </For>
                </Select>,
              )}
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item
              className="consultant-reconciliation__filter__item"
              label={t('cms.reconciliation.list.table.filter.secondary_booking_status')}
            >
              {getFieldDecorator('secondaryLandlordBookingStatus', {
                initialValue: filterForm?.secondaryLandlordBookingStatus ?? '',
              })(
                <Select
                  placeholder={t('cms.reconciliation.list.table.filter.secondary_booking_status')}
                >
                  <For of={['All', ...Object.keys(secondaryLandlordBookingStatusObj)]} each="type">
                    <Select.Option value={type} key={type}>
                      {formatUppercaseLetters(type?.toLowerCase?.()?.split?.('_')?.join?.(' '))}
                    </Select.Option>
                  </For>
                </Select>,
              )}
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              className="consultant-reconciliation__filter__item"
              label={t('cms.reconciliation.list.table.filter.move_in_date')}
            >
              {getFieldDecorator('moveInDate', {
                initialValue: [
                  filterForm?.finalMoveInDateStart
                    ? moment(filterForm?.finalMoveInDateStart)
                    : null,
                  filterForm?.finalMoveInDateEnd ? moment(filterForm?.finalMoveInDateEnd) : null,
                ],
              })(<DatePicker.RangePicker format={dateFormat} />)}
            </Form.Item>
          </Col>
        </Row>
        <Row
          gutter={24}
          className={classNames({
            'consultant-reconciliation__filter__row--hidden': showMore,
          })}
        >
          <Col span={8}>
            <Form.Item
              className="consultant-reconciliation__filter__item"
              label={t('cms.reconciliation.list.table.filter.move_out_date')}
            >
              {getFieldDecorator('moveOutDate', {
                initialValue: [
                  filterForm?.finalMoveOutDateStart
                    ? moment(filterForm?.finalMoveOutDateStart)
                    : null,
                  filterForm?.finalMoveOutDateEnd ? moment(filterForm?.finalMoveOutDateEnd) : null,
                ],
              })(<DatePicker.RangePicker format={dateFormat} />)}
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item
              className="consultant-reconciliation__filter__item"
              label={t('cms.reconciliation.list.table.filter.created_date')}
            >
              {getFieldDecorator('createdDate', {
                initialValue: [
                  filterForm?.createdAtStart ? moment(filterForm?.createdAtStart) : null,
                  filterForm?.createdAtEnd ? moment(filterForm?.createdAtEnd) : null,
                ],
              })(<DatePicker.RangePicker format={dateFormat} />)}
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              className="consultant-reconciliation__filter__item"
              label={t('cms.reconciliation.list.table.filter.completed_date')}
            >
              {getFieldDecorator('completedDate', {
                initialValue: [
                  filterForm?.completedAtStart ? moment(filterForm?.completedAtStart) : null,
                  filterForm?.completedAtEnd ? moment(filterForm?.completedAtEnd) : null,
                ],
              })(<DatePicker.RangePicker format={dateFormat} />)}
            </Form.Item>
          </Col>
        </Row>
        <Row
          gutter={24}
          className={classNames({
            'consultant-reconciliation__filter__row--hidden': showMore,
          })}
        >
          <Col span={8}>
            <Form.Item
              className="consultant-reconciliation__filter__item"
              label={t('cms.reconciliation.list.table.filter.invoice_number')}
            >
              {getFieldDecorator('invoiceNumber', {
                initialValue: filterForm?.invoiceNumber ?? null,
              })(<Input placeholder={t('cms.reconciliation.list.table.filter.invoice_number')} />)}
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item
              className="consultant-reconciliation__filter__item"
              label={t('cms.reconciliation.list.table.filter.booking_reference')}
            >
              {getFieldDecorator('referenceId', {
                initialValue: filterForm?.referenceId ?? null,
              })(
                <Input placeholder={t('cms.reconciliation.list.table.filter.booking_reference')} />,
              )}
            </Form.Item>
          </Col>
        </Row>
        <div
          className={classNames(
            showMore
              ? 'consultant-reconciliation__filter__btns'
              : 'consultant-reconciliation__filter__btns-more',
          )}
        >
          <Button onClick={handleResetBtn}>
            {t('cms.billing.transfer.table.filter.reset.btn')}
          </Button>
          <Button
            type="primary"
            style={{ margin: '0 12px' }}
            htmlType="submit"
            onClick={handleFilter}
          >
            {t('cms.billing.transfer.table.filter.search.btn')}
          </Button>
          <button
            onClick={handleShowMoreBtn}
            className="consultant-reconciliation__filter__btn-more"
          >
            {t('cms.reconciliation.lead_generation.table.filter.more.btn')}
            <LegacyIcon type={showMore ? 'down' : 'up'} className="receive__filter__btn-icon" />
          </button>
        </div>
      </Form>
    </div>
  );
}

export default Form.create()(ConsultantReconciliationFilter);
